var map = {
	"./clock.svg": "6e22",
	"./comp-icon.svg": "8bea",
	"./downArrow.svg": "b931",
	"./downloadSvg.svg": "5b5d",
	"./eaziLogo.svg": "2b3f",
	"./eazibg.svg": "351b",
	"./github.svg": "6bff",
	"./google.svg": "ccc8",
	"./lastCurve.svg": "e119",
	"./leftArrow.svg": "f712",
	"./loc-icon.svg": "7f8f",
	"./mail-icon.svg": "8464",
	"./new-referral-bg.svg": "5f5e",
	"./newBackground.svg": "c761",
	"./newCompany.svg": "4ec2",
	"./newDownload.svg": "01ce",
	"./newEmail.svg": "3275",
	"./newEmptyAnalysis.svg": "e6b7",
	"./newImage1.svg": "94df",
	"./newImage2.svg": "d2b7",
	"./newImage3.svg": "5652",
	"./newLocation.svg": "1db6",
	"./newnewBackground.svg": "8fdd",
	"./proceedArrow.svg": "96df",
	"./receiptCurve.svg": "bf01",
	"./rightCircle.svg": "4d71",
	"./seeAll.svg": "2435",
	"./sendUsBackground.svg": "a46d",
	"./totalPayrollBackground.svg": "049e",
	"./wnpLogo.svg": "27c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";